import {
  ProductSelectionWidget,
  BoothSelectionWidget,
  ShopSelectionWidget,
  BrandSelectionWidget,
  ProductCategorySelectionWidget,
  ProductShopSelectionWidget,
} from 'components/FormWidget';

const uiSchema = () => ({
  category_id: {
    'ui:widget': ProductCategorySelectionWidget,
  },
  product_id: {
    'ui:widget': ProductSelectionWidget,
  },
  shop_id: {
    'ui:widget': ShopSelectionWidget,
  },
  booth_id: {
    'ui:widget': BoothSelectionWidget,
  },
  shop_idw: {
    'ui:widget': ShopSelectionWidget,
  },
  booth_idw: {
    'ui:widget': BoothSelectionWidget,
  },
  brand_id: {
    'ui:widget': BrandSelectionWidget,
  },
  packaged_items: {
    items: {
      product_shop_id: {
        'ui:widget': ProductShopSelectionWidget,
        'ui:options': {
          initFilter: {
            for_admin: 1,
          },
        },
      },
      quantity: {
        'ui:options': {
          adornment: 'عدد',
        },
      },
    },
  },
  co_price: {
    // 'ui:widget': BoothSelectionWidget,
    // 'ui:disabled': true,
    'ui:options': {
      adornment: 'تومان',
      convertToWord: true,
    },
  },
  me_price: {
    // 'ui:widget': BoothSelectionWidget,
    // 'ui:disabled': true,
    'ui:options': {
      adornment: 'تومان',
      convertToWord: true,
    },
  },
  stock: {
    'ui:options': {
      adornment: 'عدد',
    },
  },
  max_number_buy: {
    'ui:options': {
      adornment: 'عدد',
    },
  },
  nonexistent_number: {
    'ui:options': {
      adornment: 'عدد',
    },
  },
});

export default uiSchema;
